// extracted by mini-css-extract-plugin
module.exports = {"routing":"src-containers-Awards-Detail-Routing-styles___routing","heading":"src-containers-Awards-Detail-Routing-styles___heading"};